import { object, string } from 'yup';

const noLinkedLoansReasonSchema = object({
  'reason-for-not-linking-loans': string().required('* Reason is required'),
  'explanation-for-not-linking-loans': string().required('* Explanation is required'),
});

export default noLinkedLoansReasonSchema;
